import React from "react";
import style from "./StudentProfile.module.css";
import studentProfile from "../../../Assets/studentProfile.svg";
import location from "../../../Assets/location.svg";
import upload1 from "../../../Assets/upload1.svg";
import newdownload from "../../../Assets/newdownload.svg";

// newdownload
import call from "../../../Assets/call.svg";
import linkedin from "../../../Assets/linkedin.svg";
import symbole2 from "../../../Assets/symbole2.svg";
import Badges from "../../../constant/Badges";
import ImageCards from "../ImageCard/ImageCards";
import StudentNavbar from "../../../Components/Students/Navbar/Navbar";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getUserById, sendInvite } from "services/api";
import { useState } from "react";
import shareIcon from "Assets/share.png";
import {
  Box,
  Button,
  Center,
  Flex,
  Heading,
  Img,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Square,
  Text,
  Textarea,
} from "@chakra-ui/react";
import Swal from "sweetalert2";
import { postActions } from "redux/actions";
import * as api from "../../../services/api";
import resumeEdit from "../../../Assets/resumeEdit.svg";
import defaultImg from "../../../Assets/defaultImg.png";

import Navbar from "Components/Recruiter/Navbar/Navbar";
import { Mobileview } from "./Mobileview";
import { socket } from "socket";
import { getSearchParam } from "helper/helper";

const StudentProfile = ({ isShare }) => {
  const { id } = useParams();
  const [userid, setuserid] = useState("");
  const [share, setShare] = useState("");

  const [studentData, setStudentData] = useState({});
  const [loading, setLoading] = useState(false);
  const posts = useSelector((state) => state.post.data);
  const [text, setText] = useState("");
  const [company, setCompany] = useState([]);
  const [selectedJobId, setSelectedJobId] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpen1, setModalOpen1] = useState({
    name: "",
    jobTitle: "",
    image: "",
    isOpen: false,
    id: "",
  });
  // console.log(posts);
  const student = useSelector((state) => state.student);

  const user = useSelector((state) => state);

  // console.log('user', user.auth.user.profile);
  const [error, setError] = useState(false);

  const finalRef = React.useRef(null);
  const dispatch = useDispatch();
  const [uploaded, setUploaded] = useState();

  useEffect(() => {
    if (window.location.href.includes("?id=")) {
      let userid = window.location.href.split("?id=")[1].split("&")[0];
      let share = window.location.href.split("?id=")[1].split("&")[1];
      setuserid(userid);
      setShare(share);
    }
    const userid = getSearchParam("id");
    if (id || userid) {
      const fetchUser = async () => {
        const { data } = await api.userById(id || userid);
        setStudentData(data?.data);
      };
      fetchUser();
    }
  }, [id]);

  useEffect(() => {
    if (student) {
      setStudentData(student);
    }
  }, [student]);

  const modalOpenHandler = () => {
    setModalOpen(true);
  };

  const navigate = useNavigate();

  const sendInviteHandler = async (studentId, postId) => {
    try {
      await sendInvite(studentId, postId);
      setModalOpen(false);
      Swal.fire({
        icon: "success",
        title: "Invitation Sent..",
        timer: 1300,
      });
    } catch (e) {
      Swal.fire({
        icon: "error",
        title: "OOPS! Something went wrong.",
        timer: 1300,
      });
    }
  };

  useEffect(() => {
    if (!id) return;
    const user = JSON.parse(localStorage.getItem("user"));

    if (user?.profile === "recruiter") {
      dispatch(postActions.getPosts(user.companyId, "active", setLoading));
    }
  }, [id]);

  // upload resume
  const uploadFile = (selectedFile) => {
    const { type, name, size } = selectedFile;
    // Displaying name and type of file for verification
    // console.log('Name: ', name, 'Type:', type, 'Size: ', size);
    // setFileAsset(selectedFile);
    // Check type and use any suitable upload logic as per your backend system here.
    const formData = new FormData();
    formData.append("file", selectedFile);
    api.uploadResume(formData).then((res) => {
      if (res.status === 201) {
        Swal.fire({
          icon: "success",
          text: "Resume uploaded successfully!",
          timer: 1300,
        });
      }
      setStudentData({ ...studentData, resume: selectedFile.name });
      setUploaded(true);
    });
  };
  const uploadHandler = (e) => {
    e.preventDefault();
    const selectedFile = e.target.files[0];
    const fileSize = selectedFile.size;
    const fileSizeMb = fileSize / 1024 ** 2;

    if (fileSizeMb < 5) {
      const allowedExtensions = /(\.pdf)$/i;
      if (!allowedExtensions.exec(selectedFile?.name)) {
        // Swal.fire("Please upload pdf file only...");
        Swal.fire({
          icon: "warning",
          text: "Please upload pdf file only...",
          timer: 1300,
        });
        return;
      }
      uploadFile(selectedFile);
    } else {
      Swal.fire({
        icon: "warning",
        text: "File size should be less than 5MB",
        timer: 1300,
      });
    }
  };

  const donwloadResume = () => {
    const link = document.createElement("a");
    link.href = studentData.resume;
    link.target = "_blank";
    link.click();
  };

  const sendMessage = async () => {
    try {
      const res = await api.addNewUser({
        userId: JSON.parse(localStorage.getItem("user"))._id,
        name: modalOpen1.name,
        image: modalOpen1.image,
        jobTitle: modalOpen1.jobTitle,
        consumerId: modalOpen1.id,
      });
      setModalOpen1({
        name: "",
        value: "",
        image: "",
        isOpen: false,
        id: "",
      });
      const name = user.name + "_" + "recruiter";
      const room = modalOpen1.id + "_" + user?._id;
      const chat = {
        message: text,
        room: room,
        username: user.name + "_" + "recruiter",
        timestamp: new Date(),
      };

      socket.emit("login", { name, room }, (err) => {
        socket.emit("message", chat);
        if (err) {
          return;
        } else {
        }
      });

      Swal.fire({
        title: "Success",
        text: "Message sent successfully",
        icon: "success",
        timer: 1500,
      });
    } catch (err) {
      setModalOpen1({
        name: "",
        value: "",
        image: "",
        isOpen: false,
        id: "",
      });
      Swal.fire({
        title: "Error",
        text: "Something went wrong",
        icon: "error",
      });
    }
  };

  const shareLink = () => {
    let link;
    if (isShare) {
      link =
        window.location.origin +
        "/hiring/student/profile?id=" +
        studentData._id +
        "&share=true";
    } else {
      link = window.location.href + "?id=" + studentData._id + "&share=true";
    }
    navigator.clipboard.writeText(link);
    Swal.fire({
      title: "Success",
      text: "Link copied successfully",
      icon: "success",
      timer: 1000,
    });
  };

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
      >
        <ModalOverlay />
        <ModalContent borderRadius={15} mt={20}>
          <ModalHeader>
            <Heading fontSize={32} fontWeight={600}>
              Select Job Post
            </Heading>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody height={500}>
            <Box>
              {posts?.map((post, idx) => (
                <Box
                  key={post?._id}
                  border="1px solid #E7E6E8;"
                  borderRadius={20}
                  mb={2}
                  onClick={() => setSelectedJobId(post._id)}
                  style={
                    selectedJobId === post._id
                      ? { border: "1px solid #6c56fb" }
                      : {}
                  }
                >
                  <Flex align="center" gap={2} p={4}>
                    <Box>
                      <Square
                        borderRadius={5}
                        size={55}
                        border={"1px solid #ececec"}
                      >
                        {/* logo */}
                        <Img
                          objectFit={"cover"}
                          src={post?.companyID?.profilePhoto}
                          alt="logo"
                        />
                      </Square>
                    </Box>
                    <Box>
                      <Text fontSize={20} fontWeight={600}>
                        {post.jobRoleTitle}
                      </Text>
                      <Text fontSize={16} fontWeight={600}>
                        {company[idx]}
                      </Text>
                    </Box>
                  </Flex>
                </Box>
              ))}
              {posts?.length === 0 && (
                <Text
                  py={4}
                  fontSize={20}
                  fontFamily={"Roboto"}
                  fontWeight={600}
                  textAlign={"center"}
                >
                  No Active Post
                </Text>
              )}
            </Box>
          </ModalBody>
          <ModalFooter>
            <Center>
              <Flex gap={5} mr={70}>
                <Button
                  border="1px solid #CECCD1"
                  w={118}
                  h={41}
                  py={2}
                  justify="center"
                  borderRadius={12}
                  cursor="pointer"
                  onClick={() => setModalOpen(false)}
                >
                  <Text fontSize={18} fontWeight={600} color="#2C2C2C">
                    Discard
                  </Text>
                </Button>
                <Button
                  _hover={{ bg: "#8E48FF" }}
                  w={118}
                  h={41}
                  py={2}
                  justify="center"
                  bg="#6c56fb"
                  cursor="pointer"
                  borderRadius={12}
                  disabled={selectedJobId === ""}
                  onClick={() =>
                    sendInviteHandler(studentData?._id, selectedJobId)
                  }
                >
                  <Text fontSize={18} fontWeight={500} color="#FFFFFF">
                    Invite
                  </Text>
                </Button>
              </Flex>
            </Center>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal
        size={["sm", "sm", "lg", "lg"]}
        isCentered={true}
        isOpen={modalOpen1.isOpen}
        onClose={() =>
          setModalOpen1({
            name: "",
            image: "",
            jobTitle: "",
            isOpen: false,
            id: "",
          })
        }
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Text fontSize={32} fontWeight={600} fontFamily={"Epilogue"}>
              Send a message
            </Text>
            <Text fontSize={16} fontWeight={500} fontFamily={"Epilogue"}>
              Write message to candidate
            </Text>
          </ModalHeader>
          <ModalCloseButton zIndex={99} />
          <ModalBody>
            <Flex align="center" gap={5} mb={5}>
              <Textarea
                placeholder="Write a message"
                fontFamily={"Roboto"}
                w={"100%"}
                h={"200px"}
                resize={"unset"}
                bg={"linear-gradient(0deg, #F4F4F4, #F4F4F4)"}
                onChange={(e) => setText(e.target.value)}
              />
            </Flex>
            {error && <Text color={"red.600"}>Write a message</Text>}
            <Flex justifyContent={"end"} gap={2}>
              {/* <button
                    className="btn-primary-custom"
                    onClick={() => sendMessage()}
                  >
                    send
                  </button> */}
              <Button
                color={"#FFFFFF"}
                fontSize={16}
                w={28}
                fontFamily={"Roboto"}
                fontWeight={450}
                bg={"#6C56FB"}
                borderRadius={12}
                _hover={{ background: "#6C56FB" }}
                onClick={
                  text !== ""
                    ? () => sendMessage()
                    : () => {
                        setError(true);
                      }
                }
              >
                Send
              </Button>
              <Button
                fontSize={16}
                w={28}
                fontFamily={"Roboto"}
                fontWeight={450}
                borderRadius={12}
                onClick={() =>
                  setModalOpen1({
                    isOpen: false,
                    name: "",
                    image: "",
                    jobTitle: "",
                    id: "",
                  })
                }
              >
                Discard
              </Button>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
      {/* {id ? <Navbar /> : <StudentNavbar />} */}
      <div className={style.container}>
        <div className={style.UserProfileContainer}>
          <div className={style.leftContainer}>
            <div className={style.imageContainer}>
              {studentData?.profilePhoto ? (
                <img
                  src={studentData?.profilePhoto}
                  alt=""
                  style={{
                    width: "100%",
                  }}
                  onError={(e) => (e.target.src = defaultImg)}
                />
              ) : (
                <img src={defaultImg} alt="student" />
              )}
            </div>

            <div className={style.detailsContainer}>
              <div className={style.namePrefrence}>
                <div className={style.namePrefrenceofWork}>
                  <div className={style.student_name}>{studentData?.name}</div>
                  {student?.preferredworkSpace?.length > 0 && (
                    <div className={style.tag}>Open to work</div>
                  )}
                </div>
              </div>

              <div className={style.levelLocation}>
                <div className={style.level}>{studentData?.jobTitle}</div>
                {studentData?.location?.length > 0 && "|"}
                &nbsp;
                {studentData?.location?.length > 0 &&
                  (<img src={location} alt="location" /> || (
                    <div className={style.line}></div>
                  ))}
                <div className={style.location}>
                  &nbsp;{studentData?.location}
                </div>
              </div>
              <div className={style.bio}>Bio</div>

              {studentData?.bio?.length > 0 ? (
                <p className={style.bio_details}>
                  {studentData?.bio?.length > 100 ? (
                    studentData?.bio.slice(0, 500)
                  ) : (
                    <div>
                      <p className={style.bio_details}>{studentData?.bio}</p>
                    </div>
                  )}
                </p>
              ) : (
                <>
                  {!id && !userid ? (
                    <a
                      href="/hiring/student/Editprofile"
                      className={style.addbio + " " + style.bio_details}
                    >
                      Add Bio
                    </a>
                  ) : (
                    <div className={style.call}>
                      No Bio Information Available
                    </div>
                  )}
                </>
              )}

              <div
                style={{
                  height: "88px",
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <div className={style.bio}>Badges Earned</div>
                {studentData?.badges?.length > 0 ? (
                  <div className={style.Badges}>
                    <div className={style.badgesIconContainer}>
                      <Badges data={studentData?.badges} />
                    </div>
                  </div>
                ) : (
                  <>
                    {!id && !userid ? (
                      <div className={style.badgesIconContainer}>
                        Your Earned badges will be shown here
                      </div>
                    ) : (
                      <div className={style.call}>No Badges Earned</div>
                    )}
                  </>
                )}
                {/* {studentData.badges?.length > 0 && (
                  <div className={style.Badges}>
                    <div className={style.badgesIconContainer}>
                      <Badges />
                    </div>
                  </div>
                  ********************************
                 <div className={style.badgesIconContainer}>
                    Your Earned badges will be shown here
                  </div>
                )} */}
              </div>
              <div
                className="d-flex"
                style={{
                  marginTop: "5px",
                }}
              >
                {userid && share ? null : (
                  <div
                    style={{
                      display: id ? "flex" : "block",
                    }}
                  >
                    <button
                      onClick={() =>
                        id
                          ? modalOpenHandler()
                          : navigate("/hiring/student/Editprofile")
                      }
                    >
                      {id ? "Hire Me" : "Edit Profile"}
                    </button>
                    {id && (
                      <button
                        style={{
                          marginLeft: "10px",
                        }}
                        onClick={() =>
                          id &&
                          setModalOpen1({
                            isOpen: true,
                            id: studentData._id,
                            name: studentData.name,
                            email: studentData.email,
                            image: studentData.profilePhoto,
                            jobTitle: studentData.jobTitle,
                          })
                        }
                      >
                        Message
                      </button>
                    )}
                  </div>
                )}
                {userid && share ? null : (
                  <div className="share-btn" onClick={() => shareLink()}>
                    <img src={shareIcon} height={20} width={20} />
                    &nbsp;&nbsp;
                    <a>Share Profile</a>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className={style.rightContainer}>
            <div className={style.preference}>Preferred Work Place </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                marginTop: "12px",
              }}
            >
              {studentData?.preferredworkSpace?.length > 0 ? (
                studentData?.preferredworkSpace?.map((item) => (
                  <>
                    <div className={style.preferencetag}>
                      <div>{item}</div>
                    </div>
                  </>
                ))
              ) : (
                <>
                  {!id && !userid ? (
                    <a
                      href="/hiring/student/Editprofile"
                      className={style.addbio}
                    >
                      Add preference
                    </a>
                  ) : (
                    <div className={style.nocantact}>
                      No Contact Information Available
                    </div>
                  )}
                </>
              )}
            </div>
            <div className={style.contactme}>Contact me</div>
            <div className={style.call}>
              {studentData?.phone?.length > 0 && <img src={call} lt="call" />}
              {studentData?.phone?.length > 0 ? (
                <p> &nbsp;{studentData.phone}</p>
              ) : (
                <>
                  {!id && !userid ? (
                    <a
                      href="/hiring/student/Editprofile"
                      className={style.addbio}
                    >
                      Add Contact
                    </a>
                  ) : (
                    "No Contact Information Available"
                  )}
                </>
              )}
            </div>
            <div className={style.contactme}>Social Links</div>
            {studentData?.linkedinURL?.length > 0 ? (
              <div className={style.call}>
                <a href={studentData.linkedinURL} target="_blank">
                  <img src={linkedin} alt="linkedin" />
                </a>
                <a href={studentData.customURL}>
                  <img src={symbole2} alt="symbole2" />
                </a>
              </div>
            ) : (
              <>
                {!id && !userid ? (
                  <a
                    href="/hiring/student/Editprofile"
                    className={style.addbio}
                  >
                    Add Social Links
                  </a>
                ) : (
                  <div className={style.call}>No Links Available</div>
                )}
              </>
            )}

            {/* <button className={style.btnwithTxt} onChange={uploadHandler}>
              <img src={upload1} alt='upload1' />
              {id ? 'Download Resume' : 'Upload Resume'}
            </button> */}

            {userid && share && studentData?.resume ? (
              <div
                className={style.uploadresumeCont}
                style={{
                  marginTop:
                    studentData?.preferredworkSpace?.length > 2
                      ? 26
                      : studentData?.preferredworkSpace?.length === 0
                      ? 95
                      : studentData?.preferredworkSpace?.length < 3 && 78,
                }}
              >
                <label
                  className={style.btnwithTxt}
                  onClick={() => donwloadResume(studentData?.resume)}
                >
                  <div>
                    <img
                      src={newdownload}
                      alt=""
                      style={{
                        width: "15px",
                        height: "15px",
                        backgroundColor: "#f2f2f2",
                      }}
                    />
                  </div>

                  <div className={style.resumeUpload}>Download Resume</div>
                </label>
              </div>
            ) : (
              <div
                className={style.uploadresumeCont}
                style={{
                  marginTop:
                    studentData?.preferredworkSpace?.length > 2
                      ? 26
                      : studentData?.preferredworkSpace?.length === 0
                      ? 95
                      : studentData?.preferredworkSpace?.length < 3 && 78,
                }}
              >
                {/* {console.log('res', student?.resume?.length === 0 || !upload)} */}
                {(!studentData?.resume || uploaded === false) && (
                  <label className={style.btnwithTxt}>
                    <input
                      type="file"
                      accept=".pdf"
                      style={{ width: "100%", height: "100%" }}
                      onChange={uploadHandler}
                      hidden
                      disabled={id ? true : false}
                    />
                    {!id ? (
                      <>
                        <div>
                          <img src={upload1} alt="" />
                        </div>

                        <div className={style.resumeUpload}>Upload Resume</div>
                      </>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          gap: "2px",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        onClick={() =>
                          studentData?.resume &&
                          donwloadResume(studentData?.resume)
                        }
                      >
                        <div>
                          <img src={newdownload} alt="newdownload" />
                        </div>

                        <div className={style.resumeUpload}>
                          {studentData?.resume
                            ? "Download Resume"
                            : "No Resume Uploaded"}
                        </div>
                      </div>
                    )}
                  </label>
                )}

                {(studentData?.resume?.length > 0 || uploaded === true) && (
                  <label
                    className={style.btnwithTxt}
                    onClick={() => id && donwloadResume(studentData?.resume)}
                  >
                    <input
                      type="file"
                      accept=".pdf"
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                      disabled={id ? true : false}
                      onChange={uploadHandler}
                      hidden
                    />
                    <div>
                      <img
                        src={!id ? resumeEdit : newdownload}
                        alt=""
                        style={{
                          width: "15px",
                          height: "15px",
                          backgroundColor: "#f2f2f2",
                        }}
                      />
                    </div>

                    <div className={style.resumeUpload}>
                      {id ? "Download Resume" : "Change Resume"}
                    </div>
                  </label>
                )}
                <div
                  className={style.btnwithTxt1}
                  onClick={() =>
                    studentData?.resume && donwloadResume(studentData?.resume)
                  }
                >
                  {studentData?.resume?.length > 0 &&
                  studentData?.resume?.split("/").pop()?.split(".")[0]?.length >
                    50
                    ? "resume" + ".pdf"
                    : studentData?.resume?.length > 0 && "resume" + ".pdf"}
                </div>
              </div>
            )}
          </div>
        </div>
        <ImageCards
          userid={userid ? userid : ""}
          share={share ? share : ""}
          id={studentData?._id}
          studentData={studentData}
          isRecruiter={id ? true : false}
        />
      </div>
      <div className={style.mobile}>
        <Mobileview />
      </div>
    </>
  );
};

export default StudentProfile;
